import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { Paths } from '../../../routes';
import { Status } from '../../../components';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { statusArray } from '../../../helper';
import { AnnualReviewCycle } from '../../../types/AnnualReview';
import { useAtom } from 'jotai';
import { userAtom } from '../../../store/atom';
import { useNavigate } from 'react-router-dom';

dayjs.extend(quarterOfYear);

export const allAnnualReviewsColumns: ColumnsType = [
  {
    title: 'Name of Annual Review Cycle',
    key: 'name',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) => {
      return a.name?.trim().localeCompare(b.name?.trim());
    },
    render: (data) => (
      <CycleName
        id={data.id}
        name={data.name}
        isQuarter={false}
        state={{
          from: 'mentor',
          selectedCycleId: data.id,
          isQuarter: false,
        }}
      />
    ),
  },
  {
    title: 'Review Year',
    dataIndex: '',
    key: 'year',
    render: (data: AnnualReviewCycle) => {
      return <div>{data.year}</div>;
    },
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) => {
      if (a.year && b.year) {
        return dayjs(a.year).diff(dayjs(b.year));
      }
      return 0;
    },
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'End Date',
    dataIndex: 'endDate',
    key: 'endDate',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Mentor Deadline',
    dataIndex: 'mentorDeadline',
    key: 'mentorDeadline',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) =>
      dayjs(a.mentorDeadline).diff(dayjs(b.mentorDeadline)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Annual Feedback Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (a: AnnualReviewCycle, b: AnnualReviewCycle) => {
      const first = statusArray[Number(a.status)] || a.status;
      const next = statusArray[Number(b.status)] || b.status;
      return first.toString()?.trim().localeCompare(next?.trim());
    },
    render: (status) => <Status status={status} from="quarter" />,
  },
];

const CycleName = ({
  id,
  name,
  isQuarter,
  state,
}: {
  id: string;
  name: string;
  isQuarter: boolean;
  state: any;
}) => {
  const [userState, setUserState] = useAtom(userAtom);
  const navigate = useNavigate();

  const handleClick = () => {
    setUserState({ ...userState, cycleId: id });
    navigate(`${Paths.MentorAnnualMentees}`, {
      state: { from: 'mentor', isQuarter, selectedCycleId: id, ...state },
    });
  };

  return (
    <div onClick={handleClick} className="cursor-pointer hover:text-[#69b1ff]">
      {name}
    </div>
  );
};
